import _ from 'lodash';
import CalculatorSelectInput from '../../../../calculatorInputs/CalculatorSelectInput';
import i18next from 'i18next';
import CalculatorStandardInput from '../../../../calculatorInputs/CalculatorStandardInput';
import React from 'react';

const EqualValue = ({fieldName, showLabel, availableValueOptions}) => {
  const label = showLabel ? i18next.t('calculator.dialog.create.label.values') : '';
  const selectPlaceholder = i18next.t('calculator.dialog.create.placeholder.selectValues');
  const inputPlaceholder = i18next.t('calculator.dialog.create.placeholder.indicateValue');

  const commonProps = {
    fieldName: `${fieldName}.0`,
    label,
    isRequired: true,
    uxVariant: 'criteriaInput',
    variant: 'standard',
  };

  return !_.isEmpty(availableValueOptions) ? (
    <CalculatorSelectInput
      {...commonProps}
      options={availableValueOptions}
      placeholder={selectPlaceholder}
      validate={() => null}
      labelVariant="chip"
      triggerOnContinue
    />
  ) : (
    <CalculatorStandardInput
      {...commonProps}
      placeholder={inputPlaceholder}
      validate={() => null}
      triggerOnContinue
    />
  );
}

export default EqualValue;